import { createFileRoute } from '@tanstack/react-router'
import { AuditorSamplingRoundPage, auditorPopulationSearchSchema } from '@/components/auditor-center/AuditorPopulationsPage'

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/populations_/$populationId_/rounds/$sampleId',
)({
  validateSearch: auditorPopulationSearchSchema,
  component: AuditorSamplingRoundPage,
})
